import "./DesktopPartners.css";
import { useLang } from "../../../../i18n/LangContext";

/**
 * Desktop grid с логата на партньори.
 *
 * props:
 *  - id: string (default "partners")
 *  - logos: масив от PNG/WEBP източници в същия ред като texts.partners.brands
 */
export default function DesktopPartners({
  id = "partners",
  logos = [],
}) {
  const { t } = useLang();
  const data = t?.partners;
  if (!data) return null;

  return (
    <section id={id} className="prt-root prt-desktop" aria-label="Our partners">
      <div className="prt-wrap">
        {/* TOP CENTER HEAD (същият визуално като Why Us) */}
        <div className="prt-head">
          <p className="prt-eyebrow">{data.eyebrow}</p>
          <h2 className="prt-title">{data.titleLine1}</h2>
          <h2 className="prt-title">{data.titleLine2}</h2>
        </div>

        {/* LOGO GRID */}
        <div className="prt-grid">
          {data.brands?.map((brand, idx) => (
            <article key={brand.name || idx} className="prt-card">
              <div className="prt-logo-wrap">
                {logos[idx] ? (
                  <img
                    src={logos[idx]}
                    alt={brand.alt || brand.name || "Partner logo"}
                    className="prt-logo-img"
                    loading="lazy"
                  />
                ) : (
                  <span className="prt-logo-ph" />
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
